"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var getClassNames = Utilities_1.classNamesFunction();
var DialogFooterBase = /** @class */ (function (_super) {
    tslib_1.__extends(DialogFooterBase, _super);
    function DialogFooterBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFooterBase.prototype.render = function () {
        var _a = this.props, className = _a.className, getStyles = _a.getStyles, theme = _a.theme;
        this._classNames = getClassNames(getStyles, {
            theme: theme,
            className: className
        });
        return (React.createElement("div", { className: this._classNames.actions },
            React.createElement("div", { className: this._classNames.actionsRight }, this._renderChildrenAsActions())));
    };
    DialogFooterBase.prototype._renderChildrenAsActions = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child) {
            return child ? React.createElement("span", { className: _this._classNames.action }, child) : null;
        });
    };
    DialogFooterBase = tslib_1.__decorate([
        Utilities_1.customizable('DialogFooter', ['theme'])
    ], DialogFooterBase);
    return DialogFooterBase;
}(Utilities_1.BaseComponent));
exports.DialogFooterBase = DialogFooterBase;
//# sourceMappingURL=DialogFooter.base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Dialog/DialogFooter.base.js
// module id = 778
// module chunks = 0